import { gql } from '@apollo/client'
import { CR_COUNT_TYPE_FRAGMENT } from './CRCountTypeFragment'

export const CR_COUNT_ITEM_FRAGMENT = gql`
  fragment CRCountItem on CRCountItem {
    id
    customerCount
    competitorCount
    storeAudit {
      id
    }
    countType {
      ...CRCountType
    }
  }
  ${CR_COUNT_TYPE_FRAGMENT}
`
